import { formatCurrency } from '../../../utils/formatUtils';

export const buildNotificationRowKey = (header = {}) => {
  const contract = header.contract_uuid || header.contract_number || 'contract';
  return String(contract);
};

const isValidEmail = (email) => {
  if (!email) return false;
  const normalized = String(email).trim().toLowerCase();
  return normalized.length > 0 && normalized !== 'no-user-email@gmail.com';
};

export const hasNotificationEmails = (header = {}) => {
  const subscribers = header.subscribers;
  if (Array.isArray(subscribers) && subscribers.some((sub) => isValidEmail(sub?.email))) {
    return true;
  }
  return isValidEmail(header.subscriber_email);
};

export const aggregateSelectedNotifications = (selectedMap = {}) => {
  const entries = Object.values(selectedMap);

  const coupons = entries.flatMap((entry) => Object.values(entry.coupons || {}));
  const recipients = entries.flatMap((entry) => {
    const subscribers = entry.header?.subscribers;
    if (Array.isArray(subscribers) && subscribers.length) {
      return subscribers.map((subscriber) => subscriber.email).filter(Boolean);
    }
    return entry.header?.subscriber_email ? [entry.header.subscriber_email] : [];
  });

  const totalAmount = entries.reduce((acc, entry) => {
    const header = entry.header || {};
    if (header.combined_debt_amount !== undefined && header.combined_debt_amount !== null) {
      return acc + Number(header.combined_debt_amount || 0);
    }
    return acc + Object.values(entry.coupons || {}).reduce((couponAcc, coupon) => {
      const amount = coupon.third_due_amount ?? coupon.regulariza1_amount ?? 0;
      return couponAcc + Number(amount);
    }, 0);
  }, 0);

  return {
    selectedCoupons: coupons.length,
    selectedRecipients: new Set(recipients).size,
    totalAmount,
    totalAmountLabel: formatCurrency(totalAmount),
  };
};

export const buildNotificationsPayload = (selectedMap = {}, message) => {
  const notifications = Object.values(selectedMap)
    .map((entry) => {
      const coupons = Object.values(entry.coupons || {});
      if (!coupons.length) return null;
      return {
        header: entry.header,
        coupons,
      };
    })
    .filter(Boolean);

  const payload = { notifications };
  if (message) {
    payload.message = message;
  }
  return payload;
};
